import { File, FileImage, FileText, Folder, Presentation, Video } from "lucide-react";
import type { BrandAsset } from "../types";

export function AssetPreview({ asset, large = false }: { asset: BrandAsset; large?: boolean }) {
  const iconProps = { size: large ? 42 : 30, strokeWidth: 1.5 };
  const previewToneClass = asset.previewTone ? ` asset-preview--${asset.previewTone}` : "";
  const Icon = asset.fileType === "pdf"
    ? FileText
    : asset.fileType === "folder"
      ? Folder
      : asset.fileType === "pptx"
        ? Presentation
        : asset.fileType === "mp4"
          ? Video
          : asset.fileType === "jpg" || asset.fileType === "png"
            ? FileImage
            : File;

  return (
    <div className={`asset-preview asset-preview--${asset.category}${previewToneClass} ${large ? "asset-preview--large" : ""}`}>
      {asset.previewUrl ? (
        <img src={asset.previewUrl} alt={`Превью: ${asset.title}`} />
      ) : (
        <>
          <Icon {...iconProps} aria-hidden="true" />
          <span>{asset.fileType.toUpperCase()}</span>
        </>
      )}
    </div>
  );
}
